import React from "react";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import moment from "moment";
import { ChartWrapper, MiddleWidget, PageWrapper } from "../assets/styled";
import Widgets from "../components/Widgets";
import Bar from "../components/chart/Bar";
// import Line from '../components/chart/Line';
// import Pie from '../components/chart/Pie';
import Table from "../components/Table";

const columns = [
  {
    name: "id",
    text: "ID",
    filterable: true,
    align: "left",
    sortable: false,
    type: "text",
  },
  {
    name: "User",
    text: "Satın alan",
    filterable: true,
    align: "left",
    sortable: false,
    type: "text",
    customBody: (value) => (
      <span>
        {value.name} - {value.mail}
      </span>
    ),
  },
  {
    name: "start_date",
    text: "Tarih",
    filterable: true,
    align: "left",
    sortable: false,
    type: "text",
    customBody: (value) => <span>{moment(value).format("DD.MM.YYYY")}</span>,
  },
  {
    name: "Package",
    text: "Alınna Paket",
    filterable: true,
    align: "left",
    sortable: false,
    type: "text",
    customBody: (value) => <span>{value.name}</span>,
  },
  {
    name: "Payment",
    text: "Ödeme Tipi",
    filterable: true,
    align: "left",
    sortable: false,
    type: "text",
    customBody: (value) => (
      <span>{value?.is_bulk ? "Toplu Satış Kaydı" : value?.payment_type}</span>
    ),
  },
  {
    name: "Payment",
    text: "Kupon",
    filterable: true,
    align: "left",
    sortable: false,
    type: "text",
    customBody: (value) => <span>{value?.coupon_code || "-"}</span>,
  },
  {
    name: "Payment",
    text: "Taksit",
    filterable: true,
    align: "center",
    sortable: false,
    type: "text",
    customBody: (value) => <span>{value?.installment || "-"}</span>,
  },
  {
    name: "Payment",
    text: "Cihaz",
    filterable: true,
    align: "center",
    sortable: false,
    type: "text",
    customBody: (value) => <span>{value?.device_count || "-"}</span>,
  },
  {
    name: "price",
    text: "Fiyat",
    filterable: true,
    align: "left",
    sortable: false,
    type: "text",
    customBody: (value) => (
      <span>
        {value &&
          new Intl.NumberFormat("tr-TR", {
            style: "currency",
            currency: "TRY",
          }).format(value || 0)}
      </span>
    ),
  },
];

function DashboardHook() {
  const activeUser = useSelector((state1) => state1.activeUser);
  const list = useSelector((state1) => state1.statics?.data);
  const statics = useSelector((state1) => state1.statics?.extras);

  return (
    activeUser?.user_type_id === 1 && (
      <PageWrapper>
        <Grid container spacing={3}>
          {list && (
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Widgets
                    type="sm"
                    title="Toplam Satılan Paket"
                    numberData={`${statics.totalSalesCount} Adet`}
                    accentColor="#00F2FF"
                  />
                </Grid>

                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Widgets
                    type="sm"
                    title="Toplam Satılan Miktar"
                    numberData={new Intl.NumberFormat("tr-TR", {
                      style: "currency",
                      currency: "TRY",
                    }).format(statics.totalSales)}
                    accentColor="#00FF85"
                  />
                </Grid>

                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Widgets
                    type="sm"
                    title="Geçen Ay Satılan"
                    numberData={`${statics.lastMonthSalesCount} Adet | ${new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(statics.lastMonthSales)}`}
                    accentColor="#FF9900"
                  />
                </Grid>

                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Widgets
                    type="sm"
                    title="Bu Ay Satılan"
                    numberData={`${statics.currentMonthSalesCount} Adet | ${new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(statics.currentMonthSales)}`}
                    accentColor="#9D00FF"
                  />
                </Grid>

                {/* Nereden Duymuşlar Bölümü */}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <MiddleWidget>
                    <div className="header">
                      <h5
                        style={{
                          color: "#fff",
                          fontSize: "1.2rem",
                          fontWeight: "700",
                          borderLeft: "5px solid #00F2FF",
                          paddingLeft: 15,
                          letterSpacing: "0.5px",
                        }}
                      >
                        Müşteri Kaynak Analizi
                      </h5>
                    </div>
                    <div
                      className="content"
                      style={{
                        display: "flex",
                        gap: 12,
                        flexWrap: "wrap",
                      }}
                    >
                      {statics.hearSourceData?.map((d, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "rgba(255, 255, 255, 0.03)",
                            border: "1px solid rgba(255, 255, 255, 0.08)",
                            borderRadius: "16px",
                            padding: "8px 16px",
                            transition: "all 0.2s ease",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                          }}
                        >
                          <span
                            style={{
                              color: "rgba(255, 255, 255, 0.6)",
                              fontSize: "0.9rem",
                              marginRight: 10,
                              fontWeight: "600",
                            }}
                          >
                            {d.name}
                          </span>
                          <span
                            style={{
                              color: "#00F2FF",
                              fontSize: "1.1rem",
                              fontWeight: "800",
                              background: "rgba(0, 242, 255, 0.1)",
                              padding: "2px 10px",
                              borderRadius: "10px",
                            }}
                          >
                            {d.count}
                          </span>
                        </div>
                      ))}
                    </div>
                  </MiddleWidget>
                </Grid>
              </Grid>
            </Grid>
          )}
          {/* <Grid item lg={6} md={6} sm={12} xs={12}>
            <ChartWrapper height="500px">
              <Pie debit={statics?.debitCount || 0} credit={statics?.creditCount || 0} />
            </ChartWrapper>
          </Grid> */}
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ChartWrapper height="500px">
              <Bar statics={statics?.monthData || []} />
            </ChartWrapper>
          </Grid>
          <Grid item lg={12} xs={12}>
            <Table
              data={list || []}
              columns={columns || []}
              id="reportsTable"
              options={{
                selectableRows: "none",
                header: {
                  visible: true,
                  columnSetting: false,
                },
                filter: {
                  show: true,
                  filters: [],
                  // onChange: (state, value, text, type) => console.log(state, value, text, type),
                  // drawerChange: () => setState(prevstate => ({ filterDrawer: !prevstate.filterDrawer })),
                },
                pagination: {
                  active: true,
                  perPage: 20,
                },
              }}
              // rowClick={row => console.log(row)}
              // rowClick={() => window.location.replace('/SuggestionDetail')}
            />
          </Grid>
          {/* <Grid item lg={12} md={12} sm={12} xs={12}>
            <ChartWrapper height="500px">
              <Line />
            </ChartWrapper>
          </Grid> */}
        </Grid>
      </PageWrapper>
    )
  );
}

export default DashboardHook;
